import * as React from 'react'
import { reasonLineFor } from '../paywallCopy'

export default function UpgradeHeader({ returnTo, mode, productName, reasonCode }) {
    return (
        <div className="tw-mb-6 tw-flex tw-flex-col tw-gap-1">
            <a
                href={returnTo}
                className="tw-mb-2 tw-text-sm tw-text-muted-foreground tw-no-underline hover:tw-text-foreground"
                data-testid="upgrade-back"
            >
                ← Back
            </a>
            <h1
                className="tw-m-0 tw-text-2xl tw-font-semibold"
                data-testid="upgrade-title"
            >
                {mode === 'change' ? 'Change your plan' : `Upgrade ${productName}`}
            </h1>
            <p
                className="tw-m-0 tw-text-sm tw-text-muted-foreground"
                data-testid="upgrade-reason"
            >
                {reasonCode
                    ? reasonLineFor({ code: reasonCode })
                    : 'Pick a plan, pay, and keep working. Cancel anytime.'}
            </p>
        </div>
    )
}

export function CheckoutLoadFailed({ productName }) {
    return (
        <>
            <h1 className="tw-m-0 tw-text-xl tw-font-semibold">
                Upgrade {productName}
            </h1>
            <p
                className="tw-mt-3 tw-text-sm tw-text-muted-foreground"
                data-testid="upgrade-checkout-failed"
            >
                We couldn't load your subscription, so we can't tell which plan
                you're on. Nothing was charged. Please refresh the page.
            </p>
        </>
    )
}

export function CheckoutUnavailable({ productName }) {
    return (
        <>
            <h1 className="tw-m-0 tw-text-xl tw-font-semibold">
                Upgrade {productName}
            </h1>
            <p
                className="tw-mt-3 tw-text-sm tw-text-muted-foreground"
                data-testid="upgrade-checkout-pending"
            >
                Secure in-app checkout is not switched on here yet. You can
                upgrade from the{' '}
                <a href="/subscription" className="tw-text-primary">
                    subscription page
                </a>
                .
            </p>
        </>
    )
}
